module.exports = __webpack_public_path__ + "static/img/andrew.174ff53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff-images/andrew.png
// module id = yE58
// module chunks = 0